module.exports = __webpack_public_path__ + "img/cap-logo.bf1b6085.png";